module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "aeris-notification-host",
    class: _vm.visibilityclass
  }, [_c('div', {
    class: _vm.getNotificationStyle
  }, [_c('div', {
    staticClass: "notification-text"
  }, [(_vm.spinner) ? _c('span', [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-fw"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "notification-message",
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), (_vm.closable) ? _c('div', {
    staticClass: "notification-close-button"
  }, [_c('i', {
    staticClass: "fa fa-times close-icon",
    on: {
      "click": _vm.close
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-446ec0c5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aeris-notification/aeris-notification.vue
// module id = 172
// module chunks = 0